import * as types from './types';
import axios from '../../../common/config/axios';

export const getSettingList = (data) => (dispatch, getState) => 
{
    data.country_id = getState().currentUser.data.country_id;
    axios.get('business_account_bonus_setting/list', {params: data})
    .then((res) =>
    {
        dispatch (
        {
            type: types.BUSINESS_ACCOUNT_BONUS_LIST,
            payload: res.data
        })
    })
    .catch(err => 
    {
        
    });
};

export const updateStatus = (data) => (dispatch, getState) =>
{
    // console.log(data);
    data.country_id = getState().currentUser.data.country_id;
    axios.post('business_account_bonus_setting/update_status', data)
    .then((res) =>
    {
      dispatch (
      {
        type: types.UPDATE_BUSINESS_ACCOUNT_BONUS_STATUS,
        payload: res.data
    })
    })
    .catch(err => 
    {
      
    });
};

